export default "__VITE_ASSET__BLTcG3hl__"